import { render } from "./acknowledgement.vue?vue&type=template&id=21a69a3a"
import script from "./acknowledgement.vue?vue&type=script&lang=js"
export * from "./acknowledgement.vue?vue&type=script&lang=js"

import "./acknowledgement.vue?vue&type=style&index=0&id=21a69a3a&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__